// Setting key names, and nothing else.
//
// Split out of settings.ts so a caller can name a setting without importing
// Dexie. `main.ts` — the entry chunk the browser reaches before the app bundle
// exists — needs exactly that: the two keys it prefetches through idb-raw.ts,
// with none of the 94 KB that reading them the ordinary way would drag in.
//
// settings.ts re-exports every name here, so nothing else has to know.

export const SETTING_LANGUAGE = 'ui.language';

/** The user's own number, remembered after the first successful verification —
 *  one user, many companies, the same number each time. Local only. */
export const SETTING_USER_PHONE = 'user.phone';

/** The staff surface, kept entirely apart from the buyer's own state: its own server
 *  address, its own session, its own device key alias. A phone that is both someone's
 *  buyer app and their work tool must never let one stand in for the other. */
export const SETTING_STAFF_SERVER = 'staff.serverUrl';
export const SETTING_STAFF_SESSION = 'staff.session';
